'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
  processInclude(require('core/wishlist/wishlist'));
  processInclude(window.productWishListHeart);
  processInclude(window.productWishList); // this is for the quickview heart functionality
  processInclude(require('./search/search'));
  processInclude(require('./product/quickView'));
});
